import { render, staticRenderFns } from "./ClassWallet.vue?vue&type=template&id=b6b477dc&"
import script from "./ClassWallet.vue?vue&type=script&lang=js&"
export * from "./ClassWallet.vue?vue&type=script&lang=js&"
import style0 from "./ClassWallet.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports